
<template>
  <div id="news" class="container">
    <div class="row">
      <div id="left" class="col-md-4 col-xs-12">
        <ul class="left-container wow bounceInLeft">
          <p>行业政策</p>
          <li
            v-for="(item, index) in newsList"
            :class="active == index ? 'active' : ''"
            :key="index"
          >
            <router-link @click="changeTab(index)" :to="item.path">{{
              item.name
            }}</router-link>
          </li>
        </ul>
      </div>
      <div id="right" class="col-md-8 col-xs-12 wow bounceInRight">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
export default {
  name: "news",
  data() {
    return {
      newsList: [
        {
          path: "/news/news10",
          name: "海南省加快推进数字疗法产业发展的若干措施",
        },
        {
          path: "/news/news9",
          name: "国家三级公立医院绩效考核操作手册(2022 版)",
        },
        {
          path: "/news/news2",
          name: "关于印发医疗机构检查检验结果互认管理办法的通知",
        },
        {
          path: "/news/news8",
          name: "医院智慧管理分级评估标准体系（试行）",
        },
        {
          path: "/news/news3",
          name: "三级医院评审标准（2020年版）",
        },
        {
          path: "/news/news4",
          name: "海南自由贸易港建设总体方案",
        },
        {
          path: "/news/news7",
          name: "关于支持博鳌乐城国际医疗旅游先行区发展的措施(试行)",
        },
        {
          path: "/news/news6",
          name: "医院智慧服务分级评估标准体系（试行）",
        },
      ],
      active: 0,
    };
  },
  watch: {
    // 监听到路由地址的改变
    $route: {
      immediate: true,
      handler() {
        if (this.$route.path) {
          this.newsList.forEach((element, index) => {
            if (element.path == this.$route.path) {
              this.active = index;
            }
          });
        }
      },
    },
  },
  methods: {
    changeTab(i) {
      this.active = i;
    },
  },
  created() {},
  mounted() {
    var wow = new WOW();
    wow.init();
  },
};
</script>
<style scoped>
#left {
  margin: 50px 0;
}
.active {
  background-color: #474747;
}
.active a {
  color: #fff !important;
}
.left-container {
  width: 100%;
  margin: 0 auto;
  border: 1px solid #474747;
  border-radius: 5px;
}
.left-container > p {
  text-align: center;
  line-height: 45px;
  padding: 0;
  margin: 0;
  background: #474747;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}
.left-container > li {
  text-align: left;
  padding-left: 10px;
  height: 38px;
  line-height: 38px;
  margin: 0;
  border-top: 1px solid #474747;
}
.left-container > li > a {
  text-decoration: none;
}
.left-container > li:hover {
  background: #928989;
}
#right {
  padding: 50px 0;
}
@media screen and (max-width: 768px) {
  #right {
    padding: 15px;
  }
}
</style>





// WEBPACK FOOTER //
// src/view/news.vue